module.exports = __webpack_public_path__ + "img/v3.29edf56.png";